import { render, staticRenderFns } from "./HomeBanner.vue?vue&type=template&id=8043561e&scoped=true&"
import script from "./HomeBanner.vue?vue&type=script&lang=js&"
export * from "./HomeBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8043561e",
  null
  
)

export default component.exports